import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Hiragana from './pages/Hiragana';
import Katakana from './pages/Katakana';
import Kanji from './pages/Kanji';
import Vocabulary from './pages/Vocabulary';
import Phrases from './pages/Phrases';

function App() {
  return (
    <div className="App">
      <div className="min-h-screen flex flex-col">
        <Router>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hiragana" element={<Hiragana />} />
              <Route path="/katakana" element={<Katakana />} />
              <Route path="/kanji" element={<Kanji />} />
              <Route path="/vocabulary" element={<Vocabulary />} />
              <Route path="/phrases" element={<Phrases />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </div>
    </div>
  );
}

export default App;
